import { render, staticRenderFns } from "./unidades_usuario.vue?vue&type=template&id=5519310d&scoped=true&"
import script from "./unidades_usuario.vue?vue&type=script&lang=js&"
export * from "./unidades_usuario.vue?vue&type=script&lang=js&"
import style0 from "./unidades_usuario.vue?vue&type=style&index=0&id=5519310d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5519310d",
  null
  
)

export default component.exports